module.exports = __webpack_public_path__ + "img/york.7546a3cf.webp";